import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import WallAppBar from './Components/AppBar/WallAppBar.js';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import logo from './Components/Assets/logo.png';
import { styled , createTheme, ThemeProvider } from '@mui/material/styles';
import './CSS/Images.css';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import Button from '@mui/material/Button';
import CardMedia from '@mui/material/CardMedia';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import PauseIcon from '@mui/icons-material/Pause';
import axios from 'axios';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Cookies from 'js-cookie';
import VocabCard from './Components/VocabCard.js';
import Config from "./Config.json"
import AudioButton from './Components/AudioButton.js';
import Fade from '@mui/material/Fade';

function RapidFirePage() {
    const [startTime, setStartTime] = useState(Date.now());
    const [elapsed, setElapsed ] = useState(0);
    const [beginDialogOpen, setBeginDialogOpen] = useState(true);
    const [words, setWords ] = useState([{"destWord":""}, {"destWord":""}, {"destWord":""}]);
    const [wordIndex, setWordIndex] = useState(0);
    // 0 = close, 1 = open NO dialog, 2 = open YES dialog
    const[dialogOpenState, setDialogOpenState] = React.useState(0); 
    const[startCounting, setStartCounting] = React.useState(false);
    const [quizInput, setQuizInput] = useState("");
    const [snackBarState, setSnackBarState] = useState("success");
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const [answerShowed, setAnswerShowed] = useState(false);
    const [maxTime, setMaxTime] = useState(10);

    // switch directions every now and then
    const [nativeToForeign, setNativeToForeign] = useState(true);

    useEffect(() => {
        axios.get(Config.urlStub + "/rapidFireWords", {withCredentials: true}).then((response) => {
          //lessonData = response.data;
          setWords(response.data)
        }).catch((error) => {
          console.log(error);
        });

        if (Cookies.get("session_id") != null) {
            axios.get(Config.urlStub + "/getUserPref", {withCredentials: true}).then((response) => {
                setMaxTime(response.data.rapidFireTime);
            }).catch((error) => {
            console.log(error);
            });
        }
    }, []);

    useEffect(() => {
        const interval = setInterval(myTimer , 1000);
          return () => {
            clearInterval(interval);
          };
      }, [startTime, startCounting, elapsed]);



    function submitAnswer(richtigOderFalsch) {
        // body: {"familiarity": 1 (negative if wrong answer), "word": "cow", "lang":en }
        var destLang = Cookies.get("user_destLang");
        if (destLang === undefined || destLang == null) {
            return;
        }
        var dataToSubmit = {
            "lang":Config.countryLangMapping[destLang],
            // "lang":"zh-Hans",
             "word":words[wordIndex]["destWord"],
            "familiarity":richtigOderFalsch
        };

        

        axios.post(Config.urlStub + "/updateFamiliarity", dataToSubmit, {withCredentials: true}).then((response) => {
          //lessonData = response.data;
        //   setWords(response.data)
        }).catch((error) => {
          console.log(error);
        });
    }

    function myTimer() {
        var delta = Date.now() - startTime;
        // console.log(Date.now(), startTime)
        
        if (startCounting) {
            setElapsed(elapsed + 1);
            if (elapsed + 1 >= maxTime) {
                setDialogOpenState(1);
                setStartCounting(false);
                submitAnswer(false);
            }
        }

    }

    function handleShowAnswer() {
        submitAnswer(false);
        setAnswerShowed(true);
        if (!nativeToForeign) {
            setQuizInput(words[wordIndex]["englishWord"]);
        } else {
            setQuizInput(words[wordIndex]["destWord"]);
        }
    }
        
    function nextQuestion() {

        // switch direction every 5 questions on average
        if (Math.random() < 0.2) {
            setNativeToForeign(!nativeToForeign);
        }

        setDialogOpenState(0)
        setAnswerShowed(false);
        setQuizInput("")
        setStartCounting(true)

        if (wordIndex >= words.length - 3) {
            axios.get(Config.urlStub + "/rapidFireWords", {withCredentials: true}).then((response) => {
            var newData = response.data;
            var newWords = [];
            for (var i = wordIndex; i < words.length; i++) {
                newWords.push(words[i]);
            }
            newWords = newWords.concat(newData);
            setWords(newWords);
            setWordIndex(1);
            })
        } else {
            setWordIndex(wordIndex + 1);
        }
        setStartTime(Date.now())
        setElapsed(0)
    }

    function handleDontKnow() {
        submitAnswer(false);
        setStartCounting(false);
        setDialogOpenState(1)
    }

    // remove accents for more lenient comparison
    function toNormalForm(str) {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }

    function handleKnow() {
        setStartCounting(false);
        // TODO: make pop quiz percentage customizable
        if (Math.random() < 0.1) {
            setDialogOpenState(2)
        } else {
            submitAnswer(true);
            nextQuestion();
        }
    }

    // function resetStartTime() {
    //     console.log('setting start time to', Date.now())
        
    // }

    function handleBeginDialogClose() {
        setStartTime(Date.now());
        setStartCounting(true);
        setBeginDialogOpen(false);
    }

    function handleSubmit() {
        if (!nativeToForeign) {
            if (quizInput.toLowerCase().trim(" ") === words[wordIndex]["englishWord"]
            || quizInput.toLowerCase().trim(" ") === toNormalForm(words[wordIndex]["englishWord"])) {
                setSnackBarState("success")
                submitAnswer(true);
                nextQuestion();
            } else {
                submitAnswer(false);
                setSnackBarState("error");
            }
        } else {
            if (quizInput.toLowerCase().trim(" ") === words[wordIndex]["destWord"]
            || quizInput.toLowerCase().trim(" ") === toNormalForm(words[wordIndex]["destWord"])) {
                setSnackBarState("success")
                submitAnswer(true);
                nextQuestion();
            } else {
                submitAnswer(false);
                setSnackBarState("error");
            }
        }
        setSnackBarOpen(true);        
    }

    function getDestLangFromCookies() {
        if (Cookies.get("user_destLang") !== undefined) {
          return Cookies.get("user_destLang");
        } else {
          return Cookies.get("anon_destLang");
        }
      }
    

  return (
    <Box sx={{ flexGrow:1 }} className="App-header" >
      {/* <TopAppBar breadcrumbs={breadcrumbs}/> */}
      <WallAppBar setStartCounting={setStartCounting} />

      <Stack align='center' sx={{height:'100%', alignItems:'center', justifyContent:'center', }} spacing={1.5}>
      <Typography variant="h6">
        {/* TODO: also: Do you know how to say this in ___? */}
        {/* Cookies.get("anon_destLang") */}
        {!nativeToForeign ? "Do you know this word?" : "Do you know how to say this word?"}
        </Typography>

        <Typography variant="h4" sx>
            {!nativeToForeign ? words[wordIndex]["destWord"] : words[wordIndex]["englishWord"]}
        </Typography>
            
            <Box>
            <Button onClick={() => handleDontKnow()} disabled={false}>
            <Card sx={{ minWidth: 250, maxWidth: 250 }}>
                    
                    <CardContent>
                      <Typography sx={{ fontSize: 30,  }} color="text.primary" variant="h1">
                        NO
                      </Typography>
                      <KeyboardArrowLeftIcon sx={{ fontSize: 70, display: { xs: 'none', md: 'inline' }, }}/>
                    </CardContent>
                  </Card>
          
        </Button>
        <Button onClick={() => handleKnow()} disabled={false} autofocus>
            <Card sx={{ minWidth: 250, maxWidth: 250 }}>
                    
                    <CardContent>
                    <Typography sx={{ fontSize: 30,  }} color="text.primary" variant="h1">
                       YES
                      </Typography>
                      <KeyboardArrowRightIcon sx={{ fontSize: 70, display: { xs: 'none', md: 'inline' },   }}/>
                    </CardContent>
                  </Card>
          
        </Button>

        <Dialog open={beginDialogOpen} onClose={() => handleBeginDialogClose()}
            sx={{minWidth:300}}>
            <Card sx={{ minWidth: 250,  }}>
                <CardContent>
                    <Stack spacing={1}>
                    <Typography variant="h6">
                        Welcome to Rapid Fire
                        
                    </Typography>
                    <Typography variant="body1">
                        <b>How to play:</b>
                    </Typography>

                    <Typography variant="body1" >
                        1. We give you a word <br/>
                        2. You have <b>{maxTime}</b> seconds to think of the meaning of the word <br/>
                        3. If you know the meaning, click "yes" (but we might test you!) <br></br>
                        4. If you can't think of the meaning, be honest; it's okay! <br/>`
                    </Typography>

                    <Button variant="contained" onClick={() => handleBeginDialogClose()}>START</Button>
                    </Stack>
                </CardContent>
            </Card>
        </Dialog>

        
        <Dialog open={dialogOpenState===1} onClose={() => nextQuestion()}>
            
            <Card sx={{ minWidth: 300,  }}>
                <CardContent>
                    <Stack spacing={1} sx={{alignItems:"center"}}>
                    <Typography variant="h5">
                        {elapsed >= 10 ? "Time's up!" : "Answer"}
                    </Typography>
                    {/* TODO: add picture too */}
                    <Typography variant="h6">
                        <b>{words[wordIndex]["destWord"]} = {words[wordIndex]["englishWord"]}</b>
                        <br/>
                    </Typography>
                    <img src={`data:image/jpg;base64,` + words[wordIndex]["b64"]} />

                    <AudioButton audioUrl={Config.urlStub + "" + Config.countryLangMapping[getDestLangFromCookies()]
                      + "/" + words[wordIndex]["destWord"] + ".wav"}/>

                    <Button variant="contained" onClick={() => nextQuestion()}>CLOSE</Button>

                    </Stack>
                    </CardContent>
            </Card>
        </Dialog>
        {/* nextQuestion() */}
        <Dialog open={dialogOpenState===2} onClose={() => 0}> 
        <Card sx={{ minWidth: 250,  }}>
        <CardContent>
            <Stack spacing={1} sx={{alignItems:"center"}}>
            
            <Typography variant="h6" autofocus={true}>
            {!nativeToForeign ? <>What's the meaning of <b>{words[wordIndex]["destWord"]}</b>?</> : 
            <>How do you say <b>{words[wordIndex]["englishWord"]}</b>? </>}
            </Typography>
            <TextField onChange={(e) => setQuizInput(e.target.value)} 
            inputProps={{ maxLength: 40,style: {fontSize: 35} }} 
            variant="filled" label={"Type here"}
             sx={{minWidth: '400px', margin: 1,}}
             value={quizInput} 
             onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    handleSubmit()
                }
              }}
             />
            <Button type="submit" sx={{height:70, width:"100%"}}
            variant="contained" disabled={answerShowed} onClick={() => handleSubmit()}>
                Submit
            </Button>
            <br/>
            <Button sx={{width:"50%"}} onClick={() => handleShowAnswer()}>
                Show Answer
            </Button>
            <Button sx={{width:"50%"}}  onClick={() => nextQuestion()}>Skip</Button>
            </Stack>
            </CardContent>
        </Card>
          </Dialog>

        </Box>
      </Stack>
      <Typography variant="body1" sx={{marginTop:2, opacity:"60%"}}>
        Time left: {maxTime - elapsed}s
      </Typography>

    <Snackbar open={snackBarOpen} onClose={() => setSnackBarOpen(false)} 
      anchorOrigin={{horizontal: 'center', vertical: 'bottom'}} autoHideDuration={1000}>
        <Alert severity={snackBarState} >
            {snackBarState === "success" ? "Correct!" : "Try Again"}
        </Alert> 
    </Snackbar>
    </Box>
  );
}

export default RapidFirePage;